import { render, staticRenderFns } from "./InvoiceSurcharges.vue?vue&type=template&id=453690cb&"
import script from "./InvoiceSurcharges.vue?vue&type=script&lang=js&"
export * from "./InvoiceSurcharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports